module.exports = __webpack_public_path__ + "img/watchedavideo_completed.5504d327.svg";